__turbopack_context__.v({
  "body": "tile-module-scss-module__WzlccG__body",
  "chevron": "tile-module-scss-module__WzlccG__chevron",
  "footer": "tile-module-scss-module__WzlccG__footer",
  "header": "tile-module-scss-module__WzlccG__header",
  "headerBorder": "tile-module-scss-module__WzlccG__headerBorder",
  "headerBorderMobileOnly": "tile-module-scss-module__WzlccG__headerBorderMobileOnly",
  "headerContent": "tile-module-scss-module__WzlccG__headerContent",
  "headerContentExpanded": "tile-module-scss-module__WzlccG__headerContentExpanded",
  "headerSearch": "tile-module-scss-module__WzlccG__headerSearch",
  "hiddenOnDesktop": "tile-module-scss-module__WzlccG__hiddenOnDesktop",
  "slideDown": "tile-module-scss-module__WzlccG__slideDown",
  "tabsRow": "tile-module-scss-module__WzlccG__tabsRow",
  "tabsRowBorder": "tile-module-scss-module__WzlccG__tabsRowBorder",
  "tabsRowNoMargin": "tile-module-scss-module__WzlccG__tabsRowNoMargin",
  "tile": "tile-module-scss-module__WzlccG__tile",
  "tileGrid": "tile-module-scss-module__WzlccG__tileGrid",
  "titleRow": "tile-module-scss-module__WzlccG__titleRow",
  "titleRowSpaceBetween": "tile-module-scss-module__WzlccG__titleRowSpaceBetween",
});
